import { render, staticRenderFns } from "./SpecialInspectsBindEdit.vue?vue&type=template&id=2ca88613"
import script from "./SpecialInspectsBindEdit.vue?vue&type=script&lang=js"
export * from "./SpecialInspectsBindEdit.vue?vue&type=script&lang=js"
import style0 from "./SpecialInspectsBindEdit.vue?vue&type=style&index=0&id=2ca88613&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports